import { createAction } from '@reduxjs/toolkit';
import { ITypeOfPayment } from '../../../../dto';
import { ACT_SET, TYPE_LIST, MN_TYPE_OF_PAYMENTS } from '../../../../common';

export const setTypeOfPayments = createAction<ITypeOfPayment[]>(
  `${MN_TYPE_OF_PAYMENTS}/${TYPE_LIST}/${ACT_SET}`,
);
